import { Badge } from 'react-bootstrap';

const TicketStatusBadgeComponent = ({ status, className = '' }) => {
  return (
    <div style={{ fontSize: '1rem' }} className={className + ' d-inline'}>
      <Badge
        variant={(() => {
          if (status.closed) return 'success';
          if (status.code == 'NEW') return 'warning';
          return 'secondary';
        })()}
      >
        {status.label}
      </Badge>
    </div>
  );
};

export { TicketStatusBadgeComponent as TicketStatusBadge };
